import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { HKBadge } from "@/components/site/HKBadge";
import { Seo } from "@/components/site/Seo";
import { ContactFormFields } from "@/components/site/contact/ContactFormFields";
import { ContactSuccessState } from "@/components/site/contact/ContactSuccessState";
import { ContactInfoSidebar } from "@/components/site/contact/ContactInfoSidebar";
import { useContactForm } from "@/hooks/useContactForm";

export default function ContactPage() {
  const { t } = useTranslation();
  const {
    form,
    errors,
    loading,
    success,
    setField,
    toggleArrayField,
    handleSubmit,
    resetSuccess,
  } = useContactForm();

  return (
    <div data-testid="contact-page">
      <Seo
        title={t("seo.contact.metaTitle")}
        description={t("seo.contact.metaDescription")}
        keywords={t("seo.contact.keywords")}
        path="/contact"
        breadcrumbs={[
          { name: t("seo.breadcrumbHome"), url: "/" },
          { name: t("seo.contact.breadcrumbLabel"), url: "/contact" },
        ]}
      />

      <section className="relative overflow-hidden">
        <div className="absolute inset-0 dc-dot-grid opacity-50" aria-hidden />
        <div className="relative mx-auto w-full max-w-6xl px-4 pb-10 pt-14 sm:px-6 sm:pb-14 sm:pt-20 lg:px-8">
          <HKBadge />
          <h1 className="mt-5 max-w-3xl text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl lg:text-[58px] lg:leading-[1.05]">
            {t("contact.heroTitle")}
          </h1>
          <p className="mt-4 max-w-2xl text-base text-slate-600 sm:text-lg">
            {t("contact.heroSubtitle")}
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-6xl px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-3 lg:items-start">
          <motion.form
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            onSubmit={handleSubmit}
            data-testid="professional-inquiry-form"
            className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 lg:col-span-2"
          >
            {success ? (
              <ContactSuccessState success={success} onReset={resetSuccess} />
            ) : (
              <ContactFormFields
                form={form}
                errors={errors}
                loading={loading}
                setField={setField}
                toggleArrayField={toggleArrayField}
              />
            )}
          </motion.form>

          <ContactInfoSidebar />
        </div>
      </section>
    </div>
  );
}
